var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagramRivetFinditGripRange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 374.1,
    height: 242.76,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#3c649b;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st1{fill:#3c649b}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 2.667
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.02 41.045H52.934M130.15 40.763v10.269M52.934 41.045v10.269",
    className: "st0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.3 123.64h195.6c1.2 0 2.3.3 3.4.9l14.1 8.1c2.9 1.7 4.7 4.7 4.7 8.1v12.7c0 3.3-1.8 6.4-4.7 8.1l-14.1 8c-1 .6-2.2.9-3.3.9H156.3zM52.1 114.64v64.7c-10.2 0-18.5-14.5-18.5-32.4 0-17.8 8.2-32.3 18.5-32.3z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.6 130.7c0 6-12.9 25.5-20.7 25.5H197.2c-7.8 0-20.7-19.5-20.7-25.5h51.4V55.1c0-1.7 1.4-3 3-3h70.2c1.7 0 3 1.4 3 3v75.6z",
    style: {
      fill: "#51719b"
    },
    transform: "rotate(-90 206.52 206.52)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3c649b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.667,
    d: "M100.95 39.812V10.415",
    className: "st0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramRivetFinditGripRange);
export default __webpack_public_path__ + "static/media/diagram_rivet_findit-grip-range.807ba9c9da3d366d7dc1672fafbd2ae1.svg";
export { ForwardRef as ReactComponent };